module.exports = __webpack_public_path__ + "img/header_desktop.d95edd6b.svg";